import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { DataService } from "../../../@core/services/data.service";
import { FormBuilder } from "@angular/forms";
import {
  CtaFormInterface,
  FormInput,
  FieldValue,
  SiteNewModel,
} from "../../../@core/models/site-data.model";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GoogleAnalyticsService } from "../../../@core/services/google-analytics.service";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import * as Sentry from "@sentry/browser";
import { LeadifulService } from "../../../@core/services/leadiful.service";
import { SiteModel } from "../../../@core/models/builder.model";
import { isPlatformBrowser } from "@angular/common";


declare let L: any;
@Component({
  selector: "app-cta-form-with-map",
  templateUrl: "./cta-form-with-map.component.html",
  styleUrls: ["./cta-form-with-map.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialCtaFormWithMapComponent implements OnInit, OnDestroy {
  title: string;
  leadTitle: string;
  textColor: string;
  backgroundColor: string;
  titleSize: string;
  textSize: string;
  textAlign: string;
  leadPosition: string;
  text: string;
  conversionLabel: string;
  consentText: string;
  buttonText: string = "Get Started";
  forms: FormInput[] = [];
  subscription: Subscription;
  errorMessage: string;
  data: CtaFormInterface;
  active: boolean = false;
  classBuilder: string = "";
  classField: string = "";
  position: number = 0;
  sliderIndex: number = -1;
  positionField: number = undefined;
  test: string = '';
  imageBackground: string[] | string;
  style: string = '';
  isStock: string = '';
  formData: FieldValue[] = [];
  formValid: boolean = false;
  privacyAgree: boolean = false;
  moduleInfo: string;
  editOn: boolean = false;
  displayIcons: boolean = false;
  textUnderForm: string = "";
  linkTextUnderForm: string = "";
  site: SiteModel;
  activatePadding: boolean = false;
  mapTimer: any;
  lat: number;
  lng: number;
  timeOut;
  privacyPolicyExist: boolean = false;
  privacyPolicyLink: string = '';
  successMsg: string = '';
  loading: boolean = false;
  successMsg$ = new BehaviorSubject<string>('');
  allElementAnimation: string;
  textAnimation: string;
  formAnimation: string;
  loadingData$ = new BehaviorSubject<boolean>(false);

  constructor(
    private dataService: DataService,
    @Inject(PLATFORM_ID) public platformId,
    private googleAnalyticsService: GoogleAnalyticsService,
    private analyticsService: AnalyticsService,
    private leadifulService: LeadifulService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "CtaFormWithMapComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.formAnimation = this.data.animation.form != '' ? this.data.animation.form : undefined;

    }
    this.loadingData$.next(true);
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.text = this.data.text;
    this.imageBackground = this.data.imageBackground;
    this.consentText = this.data.consentText;
    this.conversionLabel = this.data.conversionLabel;
    this.buttonText = this.data.buttonText;
    this.successMsg = this.data.successMsg ? this.data.successMsg : "Thanks for your interest. We'll get back to you soon!";
    this.leadPosition = this.data.leadPosition ? this.data.leadPosition : 'right';
    this.textAlign = this.data.textAlign ? this.data.textAlign : 'left';
    this.textColor = this.data.textColor;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize ? this.data.textSize : '';
    this.isStock = this.data.isStock;
    this.leadTitle = this.data.leadTitle;
    this.displayIcons = this.data.displayIcons;
    this.textUnderForm = this.data.textUnderForm;
    this.linkTextUnderForm = this.data.linkTextUnderForm;
    this.forms = this.data.inputs;
    this.lat = this.data.lat ? Number(this.data.lat): 40.7127281;
    this.lng = this.data.lng ? Number(this.data.lng) : -74.0060152;
    if (isPlatformBrowser(this.platformId)) {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
    this.style = this.backgroundColor.includes("#")
      ? "none"
      : this.backgroundColor;
    this.subscription = this.dataService.getCurrentSite().subscribe((site) => {
      this.privacyPolicyExist = site.privacyPolicy ? true : false;
      this.privacyPolicyLink =
        "https://" +
        (site.domainName ? site.domainName : site.siteUrl) +
        "/privacy-policy";
      this.site = site;
    });

    this.initFormData();
  }
  LoadLeaflet() {
    window.document.getElementById('global-lead-map-container-' + this.position).innerHTML = '';
    window.document.getElementById('global-lead-map-container-' + this.position).innerHTML = `<div class="mapcontainer" id="mapLeadForm-${this.position}"></div>`;
    if (window.document.getElementById('mapLeadForm-' + this.position)) {
      clearTimeout(this.mapTimer);
      window.document.getElementById('mapLeadForm-' + this.position).innerHTML = "<div  style='width: 100%; height: 100%;z-index: 0;' id='mapLeadForm-" + this.position + "'></div>";
      const url = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement('script');
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
        window.document.body.appendChild(link);
      }
      setTimeout(this.LoadMap.bind(this), 5000);
    }
    if (window.document.getElementById('mapLeadForm-' + this.position) && this.lat && this.lng) {
      setTimeout(this.LoadMap.bind(this), 2000);
    } else {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
  }
  LoadMap() {
    try {
      if (L) {
        let buttonOverlay = '';
        if (this.data.address) {
          buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 20px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: #e91e63; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">location_on</i>${this.data.address}</div></div>`
        }
        if (this.data.email) {
          buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> email </i>${this.data.email}</div></div>`
        }
        if (this.data.phone) {
          buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: green; font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> call </i>${this.data.phone}</div></div>`
        }
        if (this.data.timetable) {
          buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;blue; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">  schedule  </i>${this.data.timetable}</div></div>`
        }
        if(isNaN(Number(this.lat)) || isNaN(Number(this.lng))){
          this.lat = 40.7127281;
          this.lng = -74.0060152;
        }
        if (this.lat && this.lng) {
          var mymap = L.map('mapLeadForm-' + this.position).setView([this.lat, this.lng], 14);
          var marker = L.marker([this.lat, this.lng]).addTo(mymap).bindPopup(buttonOverlay).openPopup();;
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            minZoom: 5,
            maxZoom: 18,
            attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
          }).addTo(mymap);
        }
      } else {
        const url = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
        if (!window.document.querySelector(`script[src='${url}']`)) {
          let script = window.document.createElement('script');
          script.src = url;
          window.document.body.appendChild(script);
          let link = window.document.createElement("link");
          link.rel = "stylesheet";
          link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
          window.document.body.appendChild(link);
        }
        setTimeout(this.LoadMap.bind(this), 5000);
      }
    } catch (err) {
      const url = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement('script');
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
        window.document.body.appendChild(link);
      }
      setTimeout(this.LoadMap.bind(this), 2000);
    }
  }

  isString(val): boolean { return typeof val === 'string'; }
  saveForm($event: FieldValue) {
    this.formData[$event.position] = $event;
    this.onSubmit();
  }

  agreePrivacyPolicy($event) {
    this.privacyAgree = $event.target.checked;
    this.onSubmit();
  }

  initFormData() {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.forms.length; i++) {
      this.formData.push({ required: this.forms[i].required, value: '', type: this.forms[i].type, position: i });
    }
  }

  onSubmit() {
    let formValid: boolean = true;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.formData.length; i++) {
      if (this.formData[i].required && this.formData[i].value === "") {
        formValid = false;
      }
    }
    if (formValid && this.privacyAgree) {
      this.formValid = true;
    } else {
      this.formValid = false;
    }
  }
  setConsentChecked() {
    this.privacyAgree = !this.privacyAgree;
    this.onSubmit();
  }
  submitForm() {
    this.loading = true;
    let customFields = {};

    for (let i = 0; i < this.formData.length; i++) {
      if (this.forms[i].fieldId) {
        customFields[this.forms[i].fieldId] = this.formData[i].value;
      } else if (this.forms[i].name) {
        customFields[this.forms[i].name] = this.formData[i].value;
      } else {
        if (this.forms[i].type)
          customFields[this.forms[i].type] = this.formData[i].value;
      }
    }
    this.subscription = this.dataService.getSiteId().subscribe((siteId) => {
      const currentSite = this.dataService.site$.getValue();
      this.dataService.postLeads({
        siteId,
        customFields
      }).subscribe(res => {
        this.loading = false;
        this.successMsg$.next(this.successMsg);
        if (currentSite) {
          this.analyticsService.trackConversion(currentSite, 'conversion');
        }
        if (currentSite.googleAnalyticsPixel) {
          this.googleAnalyticsService.eventEmitter('new_lead', 'new_lead', 'new_lead_' + siteId, 'leads');
        }
        if (currentSite.plugins) {
          const leadiful = currentSite.plugins.filter(plugin => plugin.name = "leadiful" && plugin.config['leadiful_key']);
          if (leadiful.length > 0) {
            customFields['site_form_source'] = currentSite.domainName && !currentSite.domainName.includes('undefined') ? currentSite.domainName : currentSite.siteUrl;
            this.leadifulService.postLead(leadiful[0].config['campaign_id'], leadiful[0].config['leadiful_key'], customFields).subscribe(data => {
            });
          }
        }
        if (currentSite.facebookPixel) {
          this.googleAnalyticsService.FbEventEmitter('Lead', 'lead', 'Lead ', 'new_lead');
        }
        if (currentSite.googleAdwordsPixel && this.conversionLabel) {
          this.googleAnalyticsService.AdsEventEmitter(`${currentSite.googleAdwordsPixel.conversionID}/${this.conversionLabel}`, 'new_lead', 'cta_form');
        }
        this._snackBar.open(this.successMsg, '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['info-snackbar']
        });
      })
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
